import { Breadcrumb, Button, Card, Col, Input, Row, Tag } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { statusEnum } from "../../Constant/Enums";
import { pageSizeOption } from "../LMS/SubjectAlllocation/SubjectAllocation";
import SupportReqModal from "./SupportReqModal";
import { getLeaveStatus, getStatusName } from "../../Utilities/Utils";
import { useGetAPIExamQueriesGetExamQueriesList } from "../../Generated/orval-apis/exam-queries/exam-queries";
import ExamReviewModal from "./ExamReviewModal";
import { useSelector } from "react-redux";
import { RootState } from "../../Store/store";
import { selectDepartmentState } from "../../Store/Slice/departmentSlice";
import { selectBatchState } from "../../Store/Slice/batchSlice";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Navigate, useNavigate } from "react-router-dom";

const QueryList = () => {
  const department = useSelector(selectDepartmentState);
  const batch = useSelector(selectBatchState);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState({
    open: false,
    data: null,
  });
  //   const [tableRecord, setTableRecord] = useState<any>(null);
  const [pagingItems, setPagingItems] = useState({
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
    sortCol: "",
    sortDir: "",
    search: "",
  });

  const {
    data: examQueriesData,
    isLoading,
    refetch,
  } = useGetAPIExamQueriesGetExamQueriesList(
    {
      start: (pagingItems.currentPage - 1) * pagingItems.pageSize,
      length: pagingItems.pageSize,
      department: department,
      batch: batch,
      sortCol: pagingItems.sortCol,
      sortDir: pagingItems.sortDir,
      status: statusEnum.Undefined,
      search: pagingItems.search,
    },
    {}
  );

  useEffect(() => {
    if (examQueriesData?.result?.totalRecords) {
      setPagingItems((prev) => ({
        ...prev,
        totalRecords: examQueriesData?.result?.totalRecords ?? 0,
      }));
    }
  }, [examQueriesData]);

  // const showModal = () => setOpen(true);
  // const handleCancel = () => setOpen(false);

  const correctionColumn: ColumnsType<any> = [
    {
      title: "S.No",
      key: "sno",
      render: (_, __, index) =>
        (pagingItems.currentPage - 1) * pagingItems.pageSize + index + 1,
      width: "5%",
    },
    {
      title: "Student",
      dataIndex: ["student", "name"],
      key: "student",
      width: "10%",
      ellipsis: true,
    },

    {
      title: "Batch",
      dataIndex: "batch",
      key: "batch",
      width: "10%",
      ellipsis: true,
      render: (text, record) => {
        return <span>{text?.name || "-"}</span>;
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      width: "10%",
      ellipsis: true,
      render: (text, record) => {
        return <span>{text?.name || "-"}</span>;
      },
    },
    // {
    //   title: "Exam",
    //   dataIndex: "exam",
    //   key: "exam",
    //   width: "10%",
    //   ellipsis: true,
    //   render: (text, record) => {
    //     return <span>{text?.name || "-"}</span>;
    //   },
    // },
    {
      title: "Assesment",
      dataIndex: "assessmentName",
      key: "assessmentName",
      width: "10%",
      ellipsis: true,
      render: (text, record) => {
        return <span>{text || "-"}</span>;
      },
    },
    {
      title: "Applied Date",
      key: "date",
      render: (_, record) =>
        dayjs(record?.createdBy?.date).format("DD/MM/YYYY"),
      width: "10%",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: "15%",
      ellipsis: true,
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
      render: (text) => <span>{text || "-"}</span>,
      width: "15%",
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "gray";
        switch (status) {
          case statusEnum.Approve:
            color = "#87d068";
            break;
          case statusEnum.Pending:
            color = "#4F93A9";
            break;
          case statusEnum.Cancel:
            color = "#FFA500";
            break;
          case statusEnum.Reject:
            color = "#f50";
            break;
        }
        return (
          <Tag style={{ width: "80%", textAlign: "center" }} color={color}>
            {getStatusName(status)}
          </Tag>
        );
      },
      width: "10%",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          size="small"
          onClick={() => {
            setModalOpen({
              open: true,
              data: record,
            });
            // showModal();
            // setTableRecord(record);
          }}
        >
          Action
        </Button>
      ),
      width: "5%",
    },
  ];

  return (
    <>
      <Row
        justify={"space-between"}
        align="middle"
        style={{ marginBottom: "6px", padding: "0px 8px" }}
      >
        <ArrowLeftOutlined
          style={{ color: "#1677ff" }}
          onClick={() => {
            navigate(-1);
          }}
        />

        <Breadcrumb
          style={{ color: "blue" }}
          items={[
            {
              title: "Queries",
            },
          ]}
        ></Breadcrumb>
      </Row>

      <Card
        className="roundedCornerSmall"
        style={{ boxShadow: "rgba(214, 223, 245, 0.25) 0px 0px 12px" }}
      >
        <Row style={{ justifyContent: "end" }}>
          <Input.Search
            placeholder="Search..."
            allowClear
            onSearch={(value) => {
              setPagingItems({ ...pagingItems, search: value, currentPage: 1 });
            }}
            style={{ width: "220px" }}
          />
        </Row>
        <Row>
          <Col span={24} style={{ paddingTop: 10 }}>
            <Table
              className="masterList"
              loading={isLoading}
              size="small"
              columns={correctionColumn}
              dataSource={examQueriesData?.result?.items || []}
              rowKey="id"
              scroll={{ y: 600, x: 1000 }}
              pagination={{
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
                current: pagingItems.currentPage,
                pageSize: pagingItems.pageSize,
                total: pagingItems.totalRecords,
                showSizeChanger: true,
                pageSizeOptions: pageSizeOption,
              }}
              onChange={(pagination) =>
                setPagingItems({
                  ...pagingItems,
                  currentPage: pagination.current ?? 1,
                  pageSize: pagination.pageSize ?? 15,
                })
              }
            />
          </Col>
        </Row>
      </Card>

      {/* <SupportReqModal
           open={open}
           handleCancel={handleCancel}
         //   tableRecord={tableRecord}
           setRefresh={() => refetch()}
         /> */}
      <ExamReviewModal
        open={modalOpen.open}
        onClose={() => setModalOpen({ open: false, data: null })}
        // onSubmit={handleModalSubmit}
        record={modalOpen.data}
        setRefresh={() => refetch()}
      />
    </>
  );
};

export default QueryList;
